import React from 'react';
import { useTheme } from '../context/ThemeContext';
import stakeBannerBgDark from '../assets/png/stake_banner_bg-dark.png';
import stakeBannerBgLight from '../assets/png/stake_banner_bg-light.png';

const StakeBanner: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className="relative w-full md:w-[400px]">
      <div className="h-[400px] md:h-[600px] overflow-hidden rounded-lg w-full relative border border-contrast-7 dark:border-transparent">
        {/* Background image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${theme === 'dark' ? stakeBannerBgDark : stakeBannerBgLight})`,
          }}
        />

        <div className="relative z-10 flex flex-col items-center justify-end h-full px-6 md:px-8 pt-8 pb-6 md:pb-8">
          <h2 className="text-contrast-3 dark:text-white text-[20px] md:text-[24px] font-semibold font-geist mb-4 md:mb-6 text-center">
            Stake Your VLR
          </h2>

          <p className="text-contrast-5 dark:text-contrast-6 text-sm font-geist text-center mb-6 md:mb-8 leading-relaxed">
            <span className="block">
              Don't miss out on the opportunity to earn real yield every month by staking VLR token.
            </span>
            <span className="block mt-2">
              Stakers receive a share of Velora's protocol revenue and up to 95% of their trading
              gas fees.
            </span>
          </p>

          <button
            onClick={() => {
              window.open(
                'https://help.velora.xyz/en/articles/12301291-how-to-stake-vlr',
                '_blank',
              );
            }}
            className="bg-contrast-8 dark:bg-contrast-3 px-6 py-2.5 rounded-md text-contrast-4 dark:text-contrast-7 text-sm font-medium font-inter hover:bg-contrast-7 dark:hover:bg-contrast-1 transition-all"
          >
            Learn More About Staking $VLR
          </button>
        </div>
      </div>
    </div>
  );
};

export default StakeBanner;
